export default {
  name: "paginationVue",
  props: {
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 15
    },
    firstPage: {
      type: Number,
      default: 1
    },
    layoutConfig: {
      type: String,
      default: "sizes, prev, pager, next, jumper"
    }
  },
  emits: ["currentChange", "sizeChange"],
  data() {
    return {};
  },
  methods: {
    handleCurrentChange(pageNum) {
      this.$emit("currentChange", pageNum);
    },
    handleSizeChange(pageSize) {
      this.$emit("sizeChange", pageSize);
    }
  }
};